import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';
import { DafYear } from '../../api/useCharitableGivingQuery';

export const STEP_ID: Step = 'dafGrantYear';

export interface FormValues {
  dafGrantStartYear: DafYear | null;
  dafGrantEndYear: DafYear | null;
}

export const validation = yup.object().shape({
  dafGrantStartYear: yup.object().nullable(),

  dafGrantEndYear: yup
    .object()
    .nullable()
    // eslint-disable-next-line func-names
    .test('is-greater', 'End Year cannot be before the Start Year.', function(value) {
      const { dafGrantStartYear } = this.parent;

      if (!value || !dafGrantStartYear) {
        return true;
      }

      if (!value.year) {
        return true;
      }

      return value.year >= dafGrantStartYear.year;
    }),
});
